<template>
    <f-button-toggle
            :key="product.product.identifier"
            :label="label"
            :sublabel="product.product.priceString"
            :model-value="modelValue === product.product.identifier"
            @update:model-value="$emit('update:model-value', product.product.identifier)"
            :show-ribbon="showRibbon"
            :ribbon="ribbon"
            :horizontal-layout="horizontalLayout"
    />
</template>

<script>
import FButtonToggle from '/src/components/button/ButtonToggle.vue'

export default {
  name: 'PackageChoice',
  components: { FButtonToggle },
  emits: ['update:model-value'],
  props: {
    horizontalLayout: {
      type: Boolean
    },
    product: {
      type: Object,
      required: true
    },
    showRibbon: {
      type: Boolean
    },
    ribbon: {
      type: String
    },
    modelValue: {
      type: String,
      required: true
    }
  },
  computed: {
    label() {
      const key = `upgrade.packageType.${this.product.packageType}`

      return this.$t(key) === key
        ? this.product.packageType
        : this.$t(`upgrade.packageType.${this.product.packageType}`)
    }
  }
}
</script>

<style scoped>

</style>
